import {Directive, ElementRef, EventEmitter, HostListener, Inject, OnInit, Output, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {AssetStateService} from '../assets/asset.state.service';
import {Subscription} from 'rxjs';
import {AssetAction} from '../dam-header/action-bar/asset-action';

@Directive({
  selector: '[appDrawSelector]'
})
export class DrawSelectorDirective implements OnInit {
  drawRect: any;
  startX: number = 0;
  startY: number = 0;
  doDraw: boolean = false;
  mouseIsDown = false;
  actionSubscription: Subscription |undefined;
  tiles: Element [] = [];
  @Output() updateSelected = new EventEmitter();
  map: Map<Element, Function>;

  constructor(private element: ElementRef, private renderer: Renderer2,
  private assetStateService: AssetStateService,
  @Inject(DOCUMENT) private document: Document) {
    this.map = new Map();
  }
  ngOnInit() {
   // console.log('Draw Selector initialized', this.element);
    this.actionSubscription = this.assetStateService.assetAction$.subscribe(action => {
      if (action && action === AssetAction.selectNone) {
        this.clearAllAssets();
      }
    })
  }
  clearAllAssets() {
    if (this.tiles && this.tiles.length > 0) {
      for (let i = 0; i < this.tiles.length; i++) {
        if (this.tiles[i].classList.contains('drawTouched')) {
          this.tiles[i].classList.remove('drawTouched');
        }
        if (this.tiles[i].classList.contains('drawSelected')) {
          this.tiles[i].classList.remove('drawSelected');
        }
      }
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    // console.log('MouseDown', this.element.nativeElement.getBoundingClientRect(), this.element.nativeElement.scrollTop);
    this.startX = event.clientX  - this.element.nativeElement.offsetLeft ;
    this.startY = event.clientY - this.element.nativeElement.offsetTop   + this.element.nativeElement.scrollTop;
    this.mouseIsDown = true;
    setTimeout(() => {
      if (this.mouseIsDown) {
        this.addDrawRect();
        this.doDraw = true;
      }
    }, 100);

   // this.tiles = document.querySelectorAll('.asset-tile');
  }
  @HostListener('mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.mouseIsDown = false;
    this.doDraw = false
    if (this.tiles) {
      for (let i = 0; i < this.tiles.length; i++) {
        if (this.tiles[i].classList.contains('drawTouched')) {
          this.tiles[i].classList.remove('drawTouched');
        }
      }
    }
    this.removeRect()
    this.updateSelected.emit();

  }
  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent) {
    this.doDraw = false
    this.removeRect()

  }
  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.doDraw) {
      this.draw(event.x  - this.element.nativeElement.offsetLeft , event.y - this.element.nativeElement.offsetTop + this.element.nativeElement.scrollTop );
      if (this.tiles) {
        for(let i = 0; i < this.tiles.length; i++) {
          if (this.isIntersecting(this.tiles[i])) {
            this.tiles[i].classList.add('drawSelected');
            this.tiles[i].classList.add('drawTouched');
            let callback = this.map.get(this.tiles[i]);
            (callback && callback(true));

          } else {
            if (this.tiles[i].classList.contains('drawTouched')) {
              this.tiles[i].classList.remove('drawTouched');
              this.tiles[i].classList.remove('drawSelected');
              let callback = this.map.get(this.tiles[i]);
              (callback && callback(false));
            }

          }
        }
      }
    }
  }
  isIntersecting(element: Element) {
    const rect1 = element.getBoundingClientRect();
    const rect2 = this.drawRect.getBoundingClientRect();

    return !(
        rect1.right < rect2.left ||    // Element 1 is left of Element 2
        rect1.left > rect2.right ||     // Element 1 is right of Element 2
        rect1.bottom < rect2.top ||     // Element 1 is above Element 2
        rect1.top > rect2.bottom         // Element 1 is below Element 2
    );
  }
  draw(mouseX: number, mouseY: number) {
    if (this.drawRect) {
      this.renderer.setStyle(
          this.drawRect, `left`,(mouseX -  this.startX < 0) ? mouseX + 'px' : this.startX + 'px',
      );
      this.renderer.setStyle(
          this.drawRect, `top`, (mouseY - this.startY < 0) ? mouseY + 'px' :  this.startY + 'px',
      );this.renderer.setStyle(
          this.drawRect, `width`, Math.abs(mouseX - this.startX) +'px',
      );
      this.renderer.setStyle(
          this.drawRect, `height`, Math.abs(mouseY - this.startY) +  'px',
      );

    }
  }
  addDrawRect() {
    this.drawRect = this.document.createElement('div');
    this.drawRect.classList.add('draw-selector');
    this.renderer.appendChild(this.element.nativeElement, this.drawRect);
  }
  removeRect() {
    if (this.drawRect) {
      this.renderer.removeChild(this.element.nativeElement, this.drawRect);
    }

  }
  public add(element: HTMLElement , callback: Function) {
   // console.log('added tile');
    this.map.set(element, callback);
    this.tiles.push(element);
  }
  public remove(element: Element) {
    this.map.delete(element);
  }
  ngOnDestroy() {
    this.map.clear();
    this.tiles = [];
    if (this.actionSubscription) {
      this.actionSubscription.unsubscribe();
    }
  }



}
